import { callApi } from "@/api/api-core";

export const searchLocations = function(
    searchString,
    productTypes,
    ownerHandlesFailure
) {
    const requestData = {
        searchString: searchString,
        productTypes: productTypes
    };
    return callApi(
        "POST",
        "v1/location/search/name",
        requestData,
        ownerHandlesFailure
    );
};

export const searchStopsById = function(stopIds, ownerHandlesFailure) {
    return callApi(
        "POST",
        "v4/stop/search/id",
        { stopIds },
        ownerHandlesFailure
    );
};

export const searchStopsByLocation = function(
    longitude,
    latitude,
    productTypes,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v5/stop/search/location",
        {
            longitude,
            latitude,
            productTypes
        },
        ownerHandlesFailure
    );
};

export const getStopByRejseplanenId = function(
    rejseplanenId,
    productTypes,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v3/stop/get/byrejseplanenid",
        {
            rejseplanenId,
            productTypes
        },
        ownerHandlesFailure
    );
};
